import { tableColumnsType } from "../components/edit-table/editable-table";

const calculatedConsDemandColumns = ():tableColumnsType[] => {
  return (
    [
      {
        Header: 'Equipment',
        accessor: 'equipmentDescription',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Consumable Name',
        accessor: 'consumableDescription',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Code',
        accessor: 'consumableCode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Quantity',
        accessor: 'quantityRequired',
        editType: 'inputField',
        options: []
      },
      {
        Header: "Current Warehouse Qty.",
        accessor:"currentWarehouseQuantity",
        editType:'Number',

      }

    ]
  )
}

export default calculatedConsDemandColumns ;
